export default __webpack_public_path__ + "static/media/melaku.da27d10f.jpg";